// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.service-picker-container[data-v-5525dce6] {
    padding: 1.5rem;
    background: #f8f9fa;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.service-section[data-v-5525dce6] {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}
.service-header[data-v-5525dce6] {
    text-align: center;
    font-size: 1.75rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 2rem;
    letter-spacing: -0.025em;
}
.service-grid[data-v-5525dce6] {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    width: 100%;
}
.service-card-wrapper[data-v-5525dce6] {
    perspective: 1000px;
}
.service-card[data-v-5525dce6] {
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 100%;
    min-height: 120px;
}
.service-card[data-v-5525dce6]:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: #667eea;
}
.service-card.selected[data-v-5525dce6] {
    border-color: #667eea;
    background: #f8f9ff;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.service-icon[data-v-5525dce6] {
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}
.service-card:hover .service-icon[data-v-5525dce6] {
    transform: scale(1.1);
}
.service-icon i[data-v-5525dce6] {
    font-size: 1.5rem;
    color: white;
}
.service-content[data-v-5525dce6] {
    flex: 1;
    padding-right: 2.5rem;
}
.service-title[data-v-5525dce6] {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.25rem;
    transition: color 0.2s ease;
}
.service-card:hover .service-title[data-v-5525dce6] {
    color: #667eea;
}
.service-description[data-v-5525dce6] {
    color: #718096;
    line-height: 1.5;
    font-size: 0.875rem;
    margin: 0;
}
.service-arrow[data-v-5525dce6] {
    position: absolute;
    right: 1.5rem;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}
.service-card:hover .service-arrow[data-v-5525dce6] {
    transform: translateX(4px);
}
.service-arrow i[data-v-5525dce6] {
    color: #a0aec0;
    font-size: 1rem;
    transition: color 0.2s ease;
}
.service-card:hover .service-arrow i[data-v-5525dce6] {
    color: #667eea;
}
.service-card.selected .service-arrow i[data-v-5525dce6] {
    color: #667eea;
}

/* No Services Available Styles */
.no-services-container[data-v-5525dce6] {
    text-align: center;
    padding: 3rem 2rem;
}
.no-services-content[data-v-5525dce6] {
    background: white;
    border-radius: 12px;
    padding: 2.5rem;
    max-width: 450px;
    margin: 0 auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}
.no-services-icon[data-v-5525dce6] {
    width: 60px;
    height: 60px;
    background: #f3f4f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
}
.no-services-icon i[data-v-5525dce6] {
    font-size: 2rem;
    color: #667eea;
}
.no-services-content h3[data-v-5525dce6] {
    color: #2d3748;
    margin-bottom: 0.75rem;
    font-weight: 600;
    font-size: 1.25rem;
}
.no-services-content p[data-v-5525dce6] {
    color: #718096;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    font-size: 0.875rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
.service-picker-container[data-v-5525dce6] {
        padding: 1rem;
}
.service-header[data-v-5525dce6] {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
}
.service-grid[data-v-5525dce6] {
        grid-template-columns: 1fr;
        gap: 0.75rem;
}
.service-card[data-v-5525dce6] {
        padding: 1.25rem;
        min-height: 100px;
}
.service-icon[data-v-5525dce6] {
        width: 45px;
        height: 45px;
}
.service-icon i[data-v-5525dce6] {
        font-size: 1.25rem;
}
.service-title[data-v-5525dce6] {
        font-size: 1rem;
}
.service-description[data-v-5525dce6] {
        font-size: 0.813rem;
}
}

/* Animation for card appearance */
@keyframes fadeIn-5525dce6 {
from {
        opacity: 0;
        transform: translateY(10px);
}
to {
        opacity: 1;
        transform: translateY(0);
}
}
.service-card-wrapper[data-v-5525dce6] {
    animation: fadeIn-5525dce6 0.3s ease-out forwards;
}
.service-card-wrapper[data-v-5525dce6]:nth-child(1) { animation-delay: 0.05s;
}
.service-card-wrapper[data-v-5525dce6]:nth-child(2) { animation-delay: 0.1s;
}
.service-card-wrapper[data-v-5525dce6]:nth-child(3) { animation-delay: 0.15s;
}
.service-card-wrapper[data-v-5525dce6]:nth-child(4) { animation-delay: 0.2s;
}
.service-card-wrapper[data-v-5525dce6]:nth-child(5) { animation-delay: 0.25s;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
